// Relative imports only (no vite aliases): this module is imported by
// bun tests, which cannot resolve the client's runtime path aliases.
import type { FilterState } from '../../types/data-grid'
import { qs } from '../../utils/api'

/**
 * Encode per-column filters onto the wire. Format: `<column>=<op>:<value>`.
 * `like` with an empty value is dropped (nothing to match); `present` and
 * `empty` are always sent — they're operator-only and need no value.
 */
export function filtersToQueryParams(filters: Record<string, FilterState>): Record<string, string> {
  const out: Record<string, string> = {}
  for (const [column, filter] of Object.entries(filters)) {
    if (filter.operator === 'like') {
      if (filter.value) {
        out[column] = `like:${filter.value}`
      }
    } else if (filter.operator === 'present') {
      out[column] = 'present:'
    } else if (filter.operator === 'empty') {
      out[column] = 'empty:'
    }
  }
  return out
}

export interface ServerGridUrlInputs {
  endpoint: string
  params?: Record<string, unknown>
  filters: Record<string, FilterState>
  page: number
  pageSize: number
  q: string
  sortField: string
  sortOrder: string
}

/**
 * Build the request URL for one grid page. Pure — this is both the fetch
 * URL and the query key, so identical grid state always dedupes to one
 * cache entry.
 */
export function buildServerGridUrl(inputs: ServerGridUrlInputs): string {
  const { endpoint, params, filters, page, pageSize, q, sortField, sortOrder } = inputs
  return `${endpoint}${qs({
    ...(params ?? {}),
    ...filtersToQueryParams(filters),
    skip: page * pageSize,
    take: pageSize,
    q: q || undefined,
    sortField: sortField || undefined,
    sortOrder: sortOrder || undefined,
  })}`
}
